export interface PurchasePriceFromPriceListResponse {
  price: number;
  currencyCode: string;
}
